import { createEvent } from 'effector'

export const intlReset = createEvent()
